import { render, staticRenderFns } from "./ChartFilters.vue?vue&type=template&id=65e8a8f6&scoped=true"
import script from "./ChartFilters.vue?vue&type=script&lang=ts"
export * from "./ChartFilters.vue?vue&type=script&lang=ts"
import style0 from "./ChartFilters.vue?vue&type=style&index=0&id=65e8a8f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e8a8f6",
  null
  
)

export default component.exports